import { render, staticRenderFns } from "./bindView.vue?vue&type=template&id=d918b7bc&scoped=true"
import script from "./bindView.vue?vue&type=script&lang=js"
export * from "./bindView.vue?vue&type=script&lang=js"
import style0 from "./bindView.vue?vue&type=style&index=0&id=d918b7bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d918b7bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d918b7bc')) {
      api.createRecord('d918b7bc', component.options)
    } else {
      api.reload('d918b7bc', component.options)
    }
    module.hot.accept("./bindView.vue?vue&type=template&id=d918b7bc&scoped=true", function () {
      api.rerender('d918b7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/xseries/bindView.vue"
export default component.exports